// extracted by mini-css-extract-plugin
export default {"recentDocuments":"recent-documents_recentDocuments__+9xbd"};